import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Checkmark from 'images/icons/checkmark.svg'
import FilterIcon from 'images/icons/filter.svg'
import SortIcon from 'images/icons/sort.svg'
import FilterBlock, { SelectFilter } from 'components/FilterBlock'
import {
  TASTE_PROFILE_FILTER,
  PRICE_FILTER
} from 'constants/filtering'
import styles from './filterPanel.css'
import { trackTasteProfileEvent } from 'utils/tagManager'
import { COUNTRY_FILTER, ORDER_BY_FILTER } from '../../constants/filtering'

export class FilterPanel extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      active: false
    }

    this.handleToggle = this.handleToggle.bind(this)
    this.handlePriceSliderChange = this.handlePriceSliderChange.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleClickToggleFilterExpansion = this.handleClickToggleFilterExpansion.bind(this)
    this.handleSelectFilter = this.handleSelectFilter.bind(this)
  }

  renderFilters () {
    const {filters, orderings, tasteProfiles} = this.props
    return [orderings, ...filters].map((filter) =>
      <FilterBlock
        filter={filter}
        key={filter.name}
        tasteProfiles={tasteProfiles}
        onChange={{
          [TASTE_PROFILE_FILTER.NAME]: this.handleSelectFilter,
          [ORDER_BY_FILTER.NAME]: this.handleSelectFilter,
          [PRICE_FILTER.NAME]: this.handlePriceSliderChange,
          [COUNTRY_FILTER.NAME]: this.handleSelectFilter
        }[filter.name]}
        handleClickToggleFilterExpansion={this.handleClickToggleFilterExpansion}
      />
    )
  }

  render () {
    const {filters, orderings, tasteProfiles, onChangeSelectFilter} = this.props
    const {active} = this.state
    const wineTypeFilter = filters.find((filter) => filter.name === TASTE_PROFILE_FILTER.NAME)

    return (
      <div className={styles.filterPanel}>
        {wineTypeFilter && (
          <div className={styles.wineTypeFilterWrapper}>
            {wineTypeFilter.options.map(({value, selected}, index) => (
              <button
                key={value}
                className={styles.wineTypeFilterButton}
                disabled={selected}
                onClick={() => this.handleSelectFilter(TASTE_PROFILE_FILTER.NAME, value)}
              >
                <Checkmark className={styles.checkmark} />
                {TASTE_PROFILE_FILTER.OPTIONS[index]}
              </button>
            ))}
          </div>
        )}
        <div className={styles.toggleButtonWrapper}>
          <span className={classnames(styles.toggleButton, 'button')}>
            <SortIcon height={12} className={styles.filterIcon} /> Sorteer
            <SelectFilter
              filter={orderings}
              tasteProfiles={tasteProfiles}
              onChangeSelectFilter={onChangeSelectFilter}
              styles={{
                select: styles.sortwrap
              }}
            />
          </span>
          <button
            className={classnames(styles.toggleButton, 'button')}
            onClick={this.handleToggle}
            {...trackTasteProfileEvent('Filter', 'Filter')}
          >
            <FilterIcon height={12} className={styles.filterIcon} /> Filters
          </button>
        </div>
        <div className={active ? styles.panelActive : styles.panel}>
          <div className={styles.header}>
            Filters
            <button className={styles.closeButton} onClick={this.handleClose}>
              Sluit
            </button>
          </div>
          {this.renderFilters()}
          <div className={styles.footer}>
            <button
              className={styles.viewResultsButton}
              onClick={this.handleClose}
              {...trackTasteProfileEvent('Filter', 'Toon resultaten')}
            >
              Bekijk resultaten
            </button>
          </div>
        </div>
      </div>
    )
  }

  handleClickToggleFilterExpansion (filter) {
    this.props.onClickToggleExpansion(filter)
  }

  handleToggle () {
    this.setState((state) => {
      const active = !state.active
      return {active}
    })
  }

  handlePriceSliderChange ({minPrice, maxPrice}) {
    this.props.onFilterSelect(PRICE_FILTER.NAME, [minPrice, maxPrice])
  }

  handleClose () {
    this.setState(() => ({
      active: false
    }))
  }

  handleSelectFilter (filterName, value) {
    const {onFilterSelect, tasteProfiles} = this.props
    onFilterSelect(filterName, value, tasteProfiles)
  }
}

const filterShape = PropTypes.shape({
  name: PropTypes.string,
  type: PropTypes.string,
  options: PropTypes.array,
  expanded: PropTypes.bool
})

FilterPanel.propTypes = {
  orderings: filterShape.isRequired,
  filters: PropTypes.arrayOf(filterShape).isRequired,
  onFilterSelect: PropTypes.func.isRequired,
  tasteProfiles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onClickToggleExpansion: PropTypes.func.isRequired,
  onChangeSelectFilter: PropTypes.func
}

FilterPanel.defaultProps = {
  router: null,
  onChangeSelectFilter: () => {
  }
}

export default FilterPanel
